"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Header6 = exports.Header5 = exports.Header4 = exports.Header3 = exports.Header2 = exports.Header1 = exports.HeaderSixPlugin = exports.HeaderFivePlugin = exports.HeaderFourPlugin = exports.HeaderThreePlugin = exports.HeaderTwoPlugin = exports.HeaderOnePlugin = void 0;

var _header = _interopRequireDefault(require("./header1"));

var _header2 = _interopRequireDefault(require("./header2"));

var _header3 = _interopRequireDefault(require("./header3"));

var _header4 = _interopRequireDefault(require("./header4"));

var _header5 = _interopRequireDefault(require("./header5"));

var _header6 = _interopRequireDefault(require("./header6"));

var _headerDecorator = require("./headerDecorator");

var _blocks = require("@canner/slate-constant/lib/blocks");

var _isHotkey = _interopRequireDefault(require("is-hotkey"));

var _commonNode = _interopRequireDefault(require("@canner/slate-editor-renderer/lib/commonNode"));

var _slateIconShared = require("@canner/slate-icon-shared");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var plugin = function plugin(type, tagName, hotkey) {
  return {
    renderNode: function renderNode(props) {
      if (props.node.type === type) return (0, _commonNode.default)(tagName, _slateIconShared.nodeAttrs)(props);
    },
    onKeyDown: function onKeyDown(e, change) {
      if (e.key === "Enter") {
        var value = change.value;
        var blocks = value.blocks;
        var getCurrentblock = blocks.get(0);
        if (getCurrentblock.type === type) return change.splitBlock().setBlock(_blocks.PARAGRAPH);
      } else if ((0, _isHotkey.default)(hotkey, e)) {
        e.preventDefault();
        change.call(_headerDecorator.applyChange, type);
        return false;
      }
    }
  };
};

var HeaderOnePlugin = function HeaderOnePlugin() {
  var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _blocks.HEADING_1;
  return plugin(type, "h1", "ctrl+opt+1");
};

exports.HeaderOnePlugin = HeaderOnePlugin;

var HeaderTwoPlugin = function HeaderTwoPlugin() {
  var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _blocks.HEADING_2;
  return plugin(type, "h2", "ctrl+opt+2");
};

exports.HeaderTwoPlugin = HeaderTwoPlugin;

var HeaderThreePlugin = function HeaderThreePlugin() {
  var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _blocks.HEADING_3;
  return plugin(type, "h3", "ctrl+opt+3");
};

exports.HeaderThreePlugin = HeaderThreePlugin;

var HeaderFourPlugin = function HeaderFourPlugin() {
  var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _blocks.HEADING_4;
  return plugin(type, "h4", "ctrl+opt+4");
};

exports.HeaderFourPlugin = HeaderFourPlugin;

var HeaderFivePlugin = function HeaderFivePlugin() {
  var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _blocks.HEADING_5;
  return plugin(type, "h5", "ctrl+opt+5");
};

exports.HeaderFivePlugin = HeaderFivePlugin;

var HeaderSixPlugin = function HeaderSixPlugin() {
  var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _blocks.HEADING_6;
  return plugin(type, "h6", "ctrl+opt+6");
};

exports.HeaderSixPlugin = HeaderSixPlugin;
var Header1 = _header.default;
exports.Header1 = Header1;
var Header2 = _header2.default;
exports.Header2 = Header2;
var Header3 = _header3.default;
exports.Header3 = Header3;
var Header4 = _header4.default;
exports.Header4 = Header4;
var Header5 = _header5.default;
exports.Header5 = Header5;
var Header6 = _header6.default;
exports.Header6 = Header6;